import { flexRender, Table } from "@tanstack/react-table";
import { columnClassName } from "./columnClassName.ts";

export function BasicTable<T>({
  table,
  onRowClick,
  tableFixed = false,
  compact = false,
  scrollableMinWidthClassName,
}: {
  table: Table<T>;
  onRowClick?: (row: T) => void;
  tableFixed?: boolean;
  compact?: boolean;
  scrollableMinWidthClassName?: string;
}) {
  const rows = table.getRowModel().rows;
  const cellPadding = compact ? "px-3 py-3" : "px-3 md:px-6 py-3";
  const tableElement = (
    <table
      className={[
        "w-full text-sm",
        tableFixed ? "table-fixed" : "",
        scrollableMinWidthClassName ?? "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <thead className={"text-gray-700"}>
        {table.getHeaderGroups().map((headerGroup) => {
          return (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                const size = header.column.getSize();
                return (
                  <th
                    className={`${cellPadding} text-left bg-gray-50 uppercase ${columnClassName(header.column)}`}
                    key={header.id}
                    style={
                      tableFixed && size !== 150 ? { width: size } : undefined
                    }
                  >
                    {header.isPlaceholder ? null : (
                      <div>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          );
        })}
      </thead>
      <tbody>
        {rows.map((row, i) => {
          return (
            <tr
              key={row.id}
              onClick={() => onRowClick?.(row.original)}
              className={[
                i < rows.length - 1 ? "border-b border-gray-100" : "",
                onRowClick ? "cursor-pointer hover:bg-slate-50" : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              {row.getVisibleCells().map((cell) => {
                return (
                  <td
                    className={`${cellPadding} ${columnClassName(cell.column)}`}
                    key={cell.id}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  if (!scrollableMinWidthClassName) return tableElement;
  return <div className={"overflow-x-auto"}>{tableElement}</div>;
}
